import React from 'react';
import { SurveyLayouts } from "modules/MainSurveyEditor/helpers/blockForm";

import { Typography } from '@mui/material';

export const ChartTypeHeading = ({ chartDisplayType }: ChartTypeHeadingProps) => {
  const showHeading = [SurveyLayouts.Bar, SurveyLayouts.Pie].includes(chartDisplayType)
  let heading = '';
  if (!showHeading) {
    return null;
  }
  if (chartDisplayType === SurveyLayouts.Bar) {
    heading = "Chart (Bar)";
  } else if (chartDisplayType === SurveyLayouts.Pie) {
    heading = "Chart (Pie)";
  }

  return (
    <Typography variant="h4">
      {heading}
    </Typography>
  );
};

type ChartTypeHeadingProps = {
  chartDisplayType: SurveyLayouts;
};